<template>
    <div class="position-relative">
        <textarea class="form-control"
                  :placeholder="placeholder"
                  :rows="rows ? rows : 4"
                  v-model="text"
        />

        <div class="position-absolute top-0 right-0 p-3">
            <button class="btn btn-xs"
                    :class="{'disabled btn-secondary': !changed, 'btn-primary': changed}"
                    @click="save">
                <i class="fas fa-save mr-1"/>
                {{ __('actions.submit') }}
            </button>
        </div>

        <div class="d-none">
            <slot />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        action: String,
        placeholder: String,
        rows: Number
    },

    data() {
        return {
            originalText: '',
            text: '',
        };
    },

    mounted() {
        this.text = this.$slots.default[0].text;
        this.originalText = this.text;
    },

    methods: {
        save() {
            if (!this.changed) {
                return;
            }

            this.$inertia.patch(this.action, {
                message: this.text,
            })
        },
    },

    computed: {
        changed() {
            return this.text !== this.originalText;
        },
    },
};
</script>
